

































































































































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import Decisions from "@/store/modules/Decisions";
import Viewpoints from "../../store/modules/Viewpoints";
import Choices from "@/store/modules/Choices";
import Modelling from "@/store/modules/Modelling";

const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices)
const modellingModule = getModule(Modelling)
@Component({
    // Need this empty components object for the Amplify Logger
    components: {},
})

export default class SelectedInformationDebugTool extends Vue {

    private tab = ''

    get nodeEnv() {
        return process.env.NODE_ENV
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints
    }

    get selectedChoice() {
        return choicesModule.selectedChoice
    }

    get publishedModelDefinition() {
        return modellingModule.publishedDecisionModelDefinition
    }

    get workingModelDefinition() {
        return modellingModule.workingDecisionModelDefinition
    }


}
